export class Standing {
    position: number;
    teamName: string;
    teamId: number;
    gamesPlayed: number;
    points: number;
    goalDiff: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/standing.model.ts